import React from "react";
import {DocumentTypesQuery} from "../apollo/queries/DocumentTypesQuery";
import {Spinner} from "react-bootstrap";
import Select from "react-select";
import {Query} from "react-apollo";

// Exportamos el array para que pueda ser usado en otros componentes
export let documentTypes = [];

export default class DocumentTypes extends React.Component {

  setError(error) {
    console.error('Error en DocumentTypes:', error);
  }

  render() {
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'var(--input-bg)',
        borderColor: state.isFocused ? 'var(--primary-color)' : 'var(--border-color)',
        boxShadow: state.isFocused ? '0 0 0 1px var(--primary-color)' : 'none',
        '&:hover': {
          borderColor: 'var(--primary-color)'
        },
        minHeight: '38px',
        borderRadius: '8px',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--input-bg)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        textAlign: 'left'
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? 'var(--primary-color)' : 'transparent',
        color: state.isFocused ? 'white' : 'var(--text-color)',
        cursor: 'pointer',
        padding: '8px 12px',
        textAlign: 'left',
        '&:hover': {
          backgroundColor: 'var(--primary-color)',
          color: 'white'
        }
      }),
      singleValue: (provided) => ({
        ...provided,
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      input: (provided) => ({
        ...provided,
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      placeholder: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      }),
      menuList: (provided) => ({
        ...provided,
        padding: '4px 0',
        maxHeight: '200px',
        textAlign: 'left'
      }),
      noOptionsMessage: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      }),
      loadingMessage: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      }),
      indicatorSeparator: (provided) => ({
        ...provided,
        backgroundColor: 'var(--border-color)'
      }),
      dropdownIndicator: (provided) => ({
        ...provided,
        color: 'var(--text-color)'
      })
    };

    return (
      <Query query={DocumentTypesQuery} fetchPolicy={"cache-first"}
        onError={(error) => {
          this.setError(error)
        }}
      >
        {({loading, error, data}) => {
          if (loading) {
            return (
              <Spinner animation="border" role="status" style={{ marginRight: '0.5rem' }}>
                <span style={{ display: 'none' }}>Cargando...</span>
              </Spinner>
            )
          } else if (error) {
            documentTypes = [];
            return (
              <>
                <label className="form-label-custom" style={{
                  color: 'var(--text-color)',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                  display: 'block',
                  textAlign: 'left'
                }}>{this.props.label}</label>
                <Select
                  options={documentTypes}
                  onChange={this.props.handleChange}
                  value={this.props.documentType}
                  name={this.props.name}
                  isDisabled={this.props.disabled}
                  styles={customStyles}
                  placeholder="Seleccione"
                  noOptionsMessage={() => "No hay opciones disponibles"}
                  isClearable={false}
                  isSearchable={false}
                />
              </>
            )
          }
          else if (data) {
            documentTypes = [];
            data.documentTypes.forEach((item) => {
              documentTypes.push({label: item.description, value: item.id})
            });

            return (
              <>
                <label className="form-label-custom" style={{
                  color: 'var(--text-color)',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                  display: 'block',
                  textAlign: 'left'
                }}>{this.props.label}</label>
                <Select
                  options={documentTypes}
                  onChange={e=>this.props.handleChange(e, this.props.name)}
                  value={this.props.documentType}
                  name={this.props.name}
                  isDisabled={this.props.disabled}
                  styles={customStyles}
                  placeholder="Seleccione"
                  noOptionsMessage={() => "No hay opciones disponibles"}
                  isClearable={false}
                  isSearchable={false}
                />
              </>)
          }
        }}

      </Query>
    )
  }
}
